import convertUnit from "utils/convertUnit";
import { getBaseUnits, unitLabels } from "utils/fields";

/* Measurement & Unit Conversion Functions */
export const getMeasurementUnits = (displayUnits) => {
    // Check if these are already functions that do this
    // const { displayBase: areaDisplayUnits } = getBaseUnits("roomArea", displayUnits);
    // const { displayBase: tempDisplayUnits } = getBaseUnits("ashpTempCutoff", displayUnits);
    return {
        perimeterDisplayUnits: displayUnits === "Metric" ? "m" : "ft",
        areaDisplayUnits: displayUnits === "Metric" ? "m2" : "ft2",
        volumeDisplayUnits: displayUnits === "Metric" ? "m3" : "ft3",
        gainDisplayUnits: displayUnits === "Metric" ? "W" : "BTU/h",
        tempDisplayUnits: displayUnits === "Metric" ? "C" : "F", 
        airFlowDisplayUnits: displayUnits === "Metric" ? "L/s" : "cfm",
    };
}

export const convertLength = (value, unit = "m") => parseFloat(
    convertUnit({
        value: value,
        type: "length",
        inputUnit: "m",
        outputUnit: unit,
    })
).toFixed(2);

export const convertArea = (value, unit = "m2") => parseFloat(
    convertUnit({
        value: value,
        type: "area",
        inputUnit: "m2",
        outputUnit: unit,
    })
).toFixed(2);

export const convertVolume = (value, unit = "m3") => parseFloat(
    convertUnit({
        value: value,
        type: "volume",
        inputUnit: "m3",
        outputUnit: unit,
    })
).toFixed(2);

export const convertGain = (value, unit = "W") => parseFloat(
    convertUnit({
        value: value,
        type: "power",
        inputUnit: "W",
        outputUnit: unit,
    })
).toFixed(2);

export const convertTemp = (value, unit = "C") => parseFloat(
    convertUnit({
        value: value,
        type: "temperature",
        inputUnit: "C",
        outputUnit: unit,
    })
).toFixed(0);

export const convertAirFlow = (value, unit = "L/s") => parseFloat(
    convertUnit({
        value: value,
        type: "airFlow",
        inputUnit: "L/s",
        outputUnit: unit,
    })
).toFixed(1);

export const formatLength = (value, unit = "m", withSpace = true) => `${convertLength(value, unit)}${withSpace ? " " : ""}${unitLabels(unit)}`;

export const formatArea = (value, unit = "m2", withSpace = true) => `${convertArea(value, unit)}${withSpace ? " " : ""}${unitLabels(unit)}`;

export const formatVolume = (value, unit = "m3", withSpace = true) => `${convertVolume(value, unit)}${withSpace ? " " : ""}${unitLabels(unit)}`;

export const formatGain = (value, unit = "W", withSpace = true) => `${convertGain(value, unit)}${withSpace ? " " : ""}${unitLabels(unit)}`;

export const formatTemp = (value, unit = "C", withSpace = true) => `${convertTemp(value, unit)}${withSpace ? " " : ""}${unitLabels(unit)}`;

export const formatAirFlow = (value, unit = "L/s", withSpace = true) => `${convertAirFlow(value, unit)}${withSpace ? " " : ""}${unitLabels(unit)}`;